import React, { useEffect, useRef } from "react";
import ct from "class-types.macro";
import { useFormContext } from "react-hook-form";
import { DisplaySubmissionError } from "~/Brochure/SubmissionResult/DisplayHelpers";
import SubmissionResult from "~/Brochure/SubmissionResult/SubmissionResult";
import ErrorAlert from "~/common/Alert/ErrorAlert";
import { HelperSetDotNetErrors } from "~/common/Form/ValidatedForm";

interface Props {
  submissionResponse: SubmissionResult | "GeneralFailure" | undefined;
}
function EmailSignupFormErrors({ submissionResponse }: Props) {
  const { setError } = useFormContext();
  const errorWrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      submissionResponse !== undefined &&
      submissionResponse !== "GeneralFailure" &&
      submissionResponse.validationErrors !== undefined &&
      submissionResponse.validationErrors !== null
    ) {
      HelperSetDotNetErrors(submissionResponse.validationErrors, setError);

      errorWrapper.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [setError, submissionResponse]);

  return (
    <>
      {submissionResponse && (
        <div ref={errorWrapper}>
          <ErrorAlert className={ct("mb-6")}>
            {DisplaySubmissionError(submissionResponse)}
          </ErrorAlert>
        </div>
      )}
    </>
  );
}

export default EmailSignupFormErrors;
